import React from "react";
import Box from "@mui/material/Box";
import MUITabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export const Tabs = ({items}) => {
    const [value, setValue] = React.useState(0);
    return (
        <Box sx={{width: '100%'}}>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <MUITabs
                    variant={"scrollable"}
                    scrollButtons={"auto"}
                    allowScrollButtonsMobile
                    value={value}
                    onChange={(event, newValue) => setValue(newValue)}
                >
                    {items.map((item, index) => <Tab key={index} label={item.name}/>)}
                </MUITabs>
            </Box>
            {items.map((item, index) => value === index && <Box key={index} sx={{p: 3}}>{item.body}</Box>)}
        </Box>
    );
}
